import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Layout from './components/Layout';
import Home from './pages/Home';
import FAQ from './pages/FAQ';
import Terms from './pages/Terms';
import Developer from './pages/Developer';
import Socials from './pages/Socials';
import AndroidWaitlist from './pages/AndroidWaitlist';
import './App.css';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/terms.html" element={<Terms />} />
            <Route path="/developer" element={<Developer />} />
            <Route path="/socials" element={<Socials />} />
            <Route path="/android-waitlist" element={<AndroidWaitlist />} />
          </Routes>
        </Layout>
      </Router>
    </HelmetProvider>
  );
}

export default App;
